var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","id":"app","fluid":""}},[_c('div',[_vm._v("403")]),_c('div',{staticClass:"txt"},[_vm._v(" FORBIDDEN"),_c('span',{staticClass:"blink"},[_vm._v("_")])])])}
var staticRenderFns = []

export { render, staticRenderFns }